export default function () {
  let vm;

  class TopBarController {
    constructor () {
      vm = this;

      vm.listLanguages = {
        'he': { type: 'rtl', name: 'עברית' },
        'en': { type: 'ltr', name: 'English' },
        'yi': { type: 'rtl', name: 'אידיש' },
        'es': { type: 'ltr', name: 'Spanish' },
        'ru': { type: 'ltr', name: 'Русский' },
        'fr': { type: 'ltr', name: 'Français' }
      };
    }
  }

  return new TopBarController();
}



// WEBPACK FOOTER //
// ./client/app/common/top-bar/top-bar.controller.js